<template>
    <div id="vendor" class="home">
        <header-component></header-component>
        <router-view/>

        <profile-modal v-if="showProfile"></profile-modal>
        <profile-upload-message-modal v-if="showUploadMessage"></profile-upload-message-modal>
        <account-not-saved-modal v-if="showAccountNotSaved"></account-not-saved-modal>
        <account-saved-modal v-if="showAccountSaved"></account-saved-modal>
        <profile-not-saved-modal v-if="showProfileNotSaved"></profile-not-saved-modal>
        <SessionExpiringWarning v-if="showWarning"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import throttle from 'lodash/throttle'
import SessionExpiringWarning from '@/components/Home/Modals/SessionExpiringWarning'

const events = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart'
]

export default {
	components: {
		SessionExpiringWarning
	},
    data () {
        return {
        }
    },

    computed: {
        ...mapState('notify', {
            showAccountNotSaved: state => state.showAccountNotSaved,
            showAccountSaved: state => state.showAccountSaved,
            showProfileNotSaved: state => state.showProfileNotSaved,
            showUploadMessage: state => state.showUploadMessage,
        }),

        ...mapState('profile', {
            showProfile: state => state.showProfile,
        }),

        ...mapState('inactivity', {
            showWarning: state => state.showWarning,
        }),

    },
    methods: {

        checkIfStillLoggedIn(){
            var vThis = this;

            VueStore.dispatch('global/getBillingStatus');

            //Run this same function periodically
            var loggedInTimeOut = setTimeout(function(){ vThis.checkIfStillLoggedIn(); }, 30000);
            VueStore.dispatch('auth/setTimeOutVar', loggedInTimeOut);
        },
        /**
         * Methods to fetch data on load
         */
        fetachData(){
            // get logged in vendor's information
            VueStore.dispatch('vendors/getVendor');
        },

        ...mapActions('inactivity', [
            'init',
            'userActivity',
            'stop'
        ]),

        syncAcrossTabs(event) {
            if (event.key === 'lastActivity') {
                this.userActivity()
            }
        }
    },
    created(){
        // reset vuex stores for header and url using localStorage.
        VueStore.dispatch('auth/pageDone');

        this.init()

        this.activityHandler = throttle(() => {
        this.userActivity()
        }, 1000)

        events.forEach(e =>
        window.addEventListener(e, this.activityHandler)
        )

        window.addEventListener('storage', this.syncAcrossTabs)
    },

    beforeUnmount() {
        events.forEach(e =>
            window.removeEventListener(e, this.activityHandler)
        )

        window.removeEventListener('storage', this.syncAcrossTabs)
        this.stop()
    },

    mounted(){

        var vThis = this;

        $( document ).ready(function() {
            //console.log('ready');
            vThis.checkIfStillLoggedIn();
        });

        // temporary set localstorage
        window.onbeforeunload = function(event)
        {
            VueStore.dispatch('auth/pageRefresh');
        };

        vThis.fetachData();
    }

};
</script>


<style>
body{
    font-size: 14px !important;
}
.section-title {
    font-size: 14px !important;
}

.details-vp{
    color: #4e4e4e;
    padding-top: 3px;
    margin-left: 15px;
    position: relative;
    float: left;
    padding-bottom: 12px;
    cursor: pointer;
}

.details-vp-is-active{
    color: #4182D7;
    border-bottom: 4px solid #4182D7;
    padding-top: 3px;
    margin-left: 15px;
    position: relative;
    float: left;
    padding-bottom: 12px;
}

.file-delete{
    color: #dc3545;
    cursor: pointer;
}

.disable-delete{
    color: #f4f4f4;
}

.file-delete:hover{
    color: #a71d2a;
}

.uploaded-at{
    padding-right: 20px;
}

.file-header{
    color: #777777;
    font-weight: bold;
}

.file-header-date{
    margin-right: 35px;
}

.file-padded-bottom-border{
    padding-bottom: 10px;
    border-bottom: 1px solid #E8EBF4;
}

.file-padded-top{
    padding-top: 10px;
}

.view-original-file{
    font-weight: bold;
}

.view-file, .view-original-file{
    color: #4182D7;
}

.view-file:hover, .view-original-file:hover{
    cursor: pointer;
    text-decoration: underline;
}

.btn-static{
    cursor: default !important;
    width: 100px;
    color: #fff !important;
}

.btn-static:hover{
    color: #fff !important;
    cursor: default !important;
}

.btn-approved{
    background-color: #449d44;
    border-color: #398439;
}

.btn-reviewing{
    background-color: #f0ad4e;
    border-color: #eea236;
}

.btn-rejected{
    background-color: #d9534f;
    border-color: #d43f3a;
}

@media only screen and (max-width: 1024px){
    .logo-text{
        display: none;
    }

    .user-section{
        display: inherit !important;
    }
}


/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;  
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #777;
}


.status-expiring-soon{
  color: orange;
}

.status-expired, .status-incomplete {
  color: red;
}

.status-completed{
  color: green;
}

.table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 1px solid #ddd;
}


.table > tbody > tr {
    vertical-align: bottom;
    border-bottom: 1px solid #ddd;
}

.title-underline{
    border-bottom: 1px solid #ddd;
}

.clickable{
    cursor: pointer;
}

.compliance-active{
    border-bottom: 2px solid green;
    padding-bottom: 3px;
}
</style>